import Heading from '../../Typography/Heading/Heading.mjs';
import Duration from '../Duration/Duration.mjs';
import styled, { css } from 'styled-components';

const StyledMediaCardHeading = styled(Heading) `
  color: ${props => props.inverseTextColor ? props.theme.colors.textColor : props.theme.colors.white};
  margin: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  transition-property: opacity;
  transition-duration: ${props => props.theme.animation.duration.quick1};
  transition-timing-function: ${props => props.theme.animation.easing.productive.standard};
`;
const StyledMediaCardImageContainer = styled.div `
  position: relative;
  width: 100%;
  height: 141px;
  margin-bottom: 0.6rem;
  overflow: hidden;

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    height: 169px;
  }
`;
const mediaCardContainerFullWidthCss = css `
  max-width: none;

  ${StyledMediaCardImageContainer} {
    height: 211px;

    &:after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
      background: ${({ theme }) => theme.gradients.imageOverlay};
    }
  }
  ${StyledMediaCardHeading} {
    position: absolute;
    bottom: 0;
    padding: 0 1rem;
    -webkit-line-clamp: 3;
    font-size: ${({ theme }) => theme.typography.headings.h3.fontSize};
    line-height: ${({ theme }) => theme.typography.headings.h3.lineHeight};
  }
`;
const mediaCardContainerLargeCss = css `
  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    max-width: 615px;

    ${StyledMediaCardImageContainer} {
      height: 346px;
    }

    ${StyledMediaCardHeading} {
      font-size: ${({ theme }) => theme.typography.headings.h2.fontSize};
      line-height: ${({ theme }) => theme.typography.headings.h2.lineHeight};
    }
  }
`;
const mediaCardContainerFullFlexCss = css `
  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    max-width: none;

    ${StyledMediaCardImageContainer} {
      height: auto;
    }
  }
`;
const StyledMediaCardContainer = styled.a `
  display: block;
  position: relative;
  width: 100%;
  max-width: 250px;
  cursor: pointer;
  flex-shrink: 0;
  text-decoration: none;

  @media screen and (min-width: ${props => props.theme.breakpoints.sm}) {
    max-width: 300px;
  }

  @media (pointer: fine) {
    &:hover ${StyledMediaCardHeading} {
      opacity: 0.7;
    }
  }

  ${({ isLarge }) => isLarge && mediaCardContainerLargeCss}
  ${({ fullWidth }) => fullWidth && mediaCardContainerFullWidthCss}
  ${({ fullFlex }) => fullFlex && mediaCardContainerFullFlexCss}
`;
const StyledMediaCardImage = styled.img `
  position: relative;
  bottom: 1px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;
const StyledMediaCardDuration = styled(Duration) `
  position: absolute;
  z-index: ${props => props.theme.zIndex.minor};
`;

export { StyledMediaCardContainer, StyledMediaCardDuration, StyledMediaCardHeading, StyledMediaCardImage, StyledMediaCardImageContainer };
//# sourceMappingURL=MediaCard.styles.mjs.map
